<template>
  <div class="career-counselling-page study-abroad-fair">
    <section class="hero-text-img-section">
      <div class="container-fluid px-0">
        <div class="row px-3 px-lg-5 align-items-center">
          <div class="col-6 col-lg-4">
            <b-navbar-brand @click="$router.push({ path: `/` })" role="button">
              <img
                class="main-logo"
                src="@/assets/imgs/main-logo.svg"
                width="72px"
              />
            </b-navbar-brand>
          </div>
          <div class="col-6 col-lg-8 text-right">
            <a href="mailto:info@aliff.in">
              <button class="btn-secondary-red">info@aliff.in</button>
            </a>
            <!-- <a>info@aliff.in</a> -->
          </div>
        </div>
        <div class="row justify-content-center px-3 px-lg-5">
          <div class="col-lg-7 pt-5">
            <div>
              <h1 class="main-heading-1-gradient">STUDY ABROAD FAIR</h1>
              <hr />
              <h3 class="">Master / MBA Programs</h3>
              <h4 class="main-content-1 mt-2">
                A post-grad focused education fair
              </h4>
              <div class="mt-4 font-weight-bold d-flex align-items-center">
                <img
                  src="@/assets/imgs/svgs/sound.svg"
                  alt=""
                  class="img-fluid"
                  width="50px"
                />
                <h4 class="main-content-1 pl-3">Last Call for 2022 Admissions</h4>
              </div>
              <div class="event-details">
                <div>
                  <img
                    src="@/assets/imgs/svgs/map.svg"
                    alt=""
                    class="img-fluid"
                  />
                  <p>Saturday, 28 May 2022</p>
                </div>
                <div>
                  <img
                    src="@/assets/imgs/svgs/clock.svg"
                    alt=""
                    class="img-fluid"
                  />
                  <p>11am to 5pm</p>
                </div>
                <div>
                  <img
                    src="@/assets/imgs/svgs/calendar.svg"
                    alt=""
                    class="img-fluid"
                  />
                  <p>Sofitel Hotel BKC</p>
                </div>
              </div>
            </div>
            <div class="fair-hero-img">
              <img src="@/assets/imgs/city.png" alt="" />
            </div>
          </div>
          <div class="col-lg-5 pt-5 pt-lg-0">
            <div class="form-card" id="event-form">
<div class="npf_wgts" data-height="600px" data-w="3ebf2f247265251b2d52797641bad96a"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero-text-img-section fair-logos-section">
      <div class="intro-tabs mx-lg-3 gradient-box bg-primary-gradient br-0">
        <div class="tabs w-100">
          <li class="tab-content">
            <img
              src="@/assets/imgs/fair-logo-5.png"
              alt=""
              class="img-fluid"
            />
          </li>
          <li class="tab-content">
            <img src="@/assets/imgs/fair-logo-6.png" alt="" />
          </li>
          <li class="tab-content">
            <img src="@/assets/imgs/fair-logo-8.png" alt="" />
          </li>
          <li class="tab-content">
            <img src="@/assets/imgs/fair-logo-9.png" alt="" />
          </li>
           <li class="tab-content">
            <img src="@/assets/imgs/fair-logo-7.gif" alt="" />
          </li>
        </div>
      </div>
    </section>
    <section class="mb-lg-5 py-lg-5">
      <h2 class="main-heading-1-gradient text-center">
        Participating Countries
      </h2>
      <div class="search-tags" id="tags-home">
        <div
          class="tag"
          v-for="(tag, index) in search_tags"
          :key="index"
          data-aos="zoom-in"
        >
          {{ tag }}
        </div>
      </div>
    </section>
    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-6" data-aos="fade-right">
            <img
              src="@/assets/imgs/illustration-2.png"
              class="img-fluid border-all"
            />
          </div>
          <div class="col-md-6 col-xl-6" data-aos="fade-left">
            <h2 class="main-heading-1-gradient">Scholarships up-to 100%</h2>
            <ul class="list-item icon-list-item">
              <li>Meet Top Ranking Universities</li>
              <li>Meet Bank for Easy Loan</li>
              <li>On Spot Application Assessment</li>
              <li>Separate Parent Counseling</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="student-section py-xl-5 my-5">
      <div class="container-fluid bg-row py-5">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center">
            <div class="main-heading-1">Past Fair Feedback</div>
          </div>
          <div class="col-lg-12 mt-5 stu-card-section">
            <TextTestimonialSlider
              :testimonialsData="
                testimonialData['study-abroad-fair']['testimonial-1']
              "
              design="design-2"
            />
          </div>

          <!-- <div class="col-lg-12 mt-5 stu-card-section">
            <TextTestimonialSlider
              :testimonialsData="
                testimonialData['study-abroad-fair']['testimonial-2']
              "
              design="design-2"
            />
          </div> -->
        </div>
      </div>
    </section>

    <section class="awards-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center">
            <h2 class="main-heading-1-gradient text-center">
              Awards and Recognitions
            </h2>
            <!-- <p class="main-content-1">
              A line to speak about featured destination, programme, or
              university. A line to speak about featured destination, programme,
              or university
            </p> -->
          </div>
          <div class="col-lg-12 mt-5 pt-xl-5">
            <div class="team-member-cards">
              <ul class="cards">
                <li>
                  <img src="@/assets/imgs/awards-1.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-2.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-3.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-4.png" alt="" />
                </li>
              </ul>
              <ul class="cards">
                <li>
                  <img src="@/assets/imgs/awards-5.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-6.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-7.png" alt="" />
                </li>
                <li>
                  <img src="@/assets/imgs/awards-8.png" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="pb-xl-5 mb-5 mx-lg-3">
      <div class="gradient-box bg-primary-gradient">
        <div class="box-title">
          <h1 class="mb-1">
            Aliff <br />
            Milestones
          </h1>
          <p class="ratings">
            4.7/5 <img src="@/assets/imgs/rating.png" alt="" /> <br />
          </p>
          <p>Google Rating</p>
        </div>
        <div class="box-content">
          <ul class="content-list">
            <li class="content">
              <h1>10+</h1>
              <p>Years of experience</p>
            </li>
            <li class="content">
              <h1>100%</h1>
              <p>Admission Succcess Rate</p>
            </li>
            <li class="content">
              <h1>14</h1>
              <p>Easy-access Countries</p>
            </li>
            <li class="content">
              <h1>Top 10</h1>
              <p>Full Scholarship Students</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="mx-lg-3 contact-us-section py-lg-5">
      <div class="row justify-content-center">
        <div class="col-lg-4">
          <h1 class="secondary-color main-heading-1-gradient">
            <b>Fair Date and Venue</b>
          </h1>
          <h1>
            Saturday, 28 May 2022<br />
            Sofitel, bkc, mumbai
          </h1>
          <div class="pt-5">
            <a href="#event-form">
              <button class="btn-secondary-red">Register Now</button>
            </a>
          </div>
        </div>
        <div class="col-lg-4">
          <img src="@/assets/imgs/edge-out-3.png" class="img-fluid" />
        </div>
      </div>
    </section>

    <!-- <ContactusSection /> -->

    <section class="study-abroad-fair--footer text-center px-5 py-5">
      <h5>Copyright © 2021 Aliff, inc</h5>
    </section>
    <!-- <RecentPostSection
      :recentPostsData="recentPostData['career-page']['data-1']"
    /> -->
  </div>
</template>

<script>
import homeServices from "@/apiServices/homeServices";
import BookFreeCounselling from "@/components/partials/BookFreeCounselling.vue";
import { DASHBOARD_REGISTER_URL } from "@/config";

import VideoTestimonialSlider from "@/components/partials/VideoTestimonialSlider.vue";
import TextTestimonialSlider from "@/components/partials/TextTestimonialSlider.vue";
import RecentPostSection from "@/components/partials/RecentPostSection.vue";
import ContactusSection from "@/components/partials/ContactusSection.vue";

export default {
  components: {
    BookFreeCounselling,
    VideoTestimonialSlider,
    TextTestimonialSlider,
    RecentPostSection,
    ContactusSection,
  },
  data() {
    return {
      service: [],
      showPlan: false,
      DASHBOARD_REGISTER_URL,
      search_tags: [
        "USA",
        "UK",
        "Canada",
        "NZ",
        "Switzerland",
        "Singapore",
        "France",
        "Germany",
        "Dubai",
      ],
      videoSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 2.5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      pricingSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },

      postSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
    };
  },
  methods: {
    // PayNow(pp) {
    //   var elms = document.getElementById(pp).getElementsByTagName("a");
    //   elms[0].click();
    // },
    clickShowPlan() {
      this.showPlan = !this.showPlan;
    },
    async getServicePlan() {
      try {
        const response = await homeServices.getServicesAndPlans({
          service_id: 5,
        });
        if (response.data.status) {
          this.service = response.data.data[0];
        }
      } catch (err) {
        console.log("Error in getting getServicePlan ", err);
      }
    },
    addCommas(amt) {
      return amt.toLocaleString("en-IN");
    },
  },
  beforeMount() {
    this.getServicePlan();
  },
};
</script>

<style>
.study-abroad-fair .hero-text-img-section {
  /* background: linear-gradient(135deg, #5367ff 0%, #00d09c 100%); */
  /* color: white; */
}
.study-abroad-fair .page-intro-line {
  /* color: white; */
}
.study-abroad-fair .main-logo {
  /* filter: brightness(0) invert(1); */
}
.study-abroad-fair--footer {
  background: rgba(83, 103, 255, 0.05);
}
.event-details {
  /* display: flex; */
  justify-content: center;
  margin-top: 40px;
}
.event-details img {
  width: 50px;
}
.event-details div {
  display: flex;
  align-items: center;
}
.form-card {
  /* background: white; */
  background: linear-gradient(135deg, #5367ff 0%, #00d09c 100%);

  box-shadow: 0 10px 20px rgb(40 111 219 / 30%);
  border-radius: 10px;
  padding: 41px;
}
.fair-hero-img img {
  width: 100% !important;
  /* margin-top: -15%; */
}
.fair-logos-section img {
  width: 165px;
  height: 80px;
  object-fit: contain;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/StudyAbroadFair4.vue